import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("kt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
